import React from 'react';

const Contact = () => {
  return (
    <section id="contact" className="contact-section">
      <div className="container">
        <div className="section-label">Contact</div>
        <div className="contact-inner">
          <h2 className="contact-heading">Let's connect!</h2>
          <p className="contact-sub">
            Want to build a website that meets your goals?
            Whether starting from scratch or building on an existing one, I'm here to help define and develop an end-to-end solution that works for you.
          </p>
          <div className="contact-social">
            <a
              href="https://www.linkedin.com/in/nicolo-tabar/"
              target="_blank"
              rel="noreferrer"
              className="contact-social-link"
            >
              LinkedIn
            </a>
            <span className="contact-social-divider" />
            <a
              href="https://github.com/nicolotabar"
              target="_blank"
              rel="noreferrer"
              className="contact-social-link"
            >
              GitHub
            </a>
          </div>
          <a
            href="https://www.linkedin.com/in/nicolo-tabar/"
            target="_blank"
            rel="noreferrer"
            className="contact-btn"
          >
            Get in touch
          </a>
        </div>
      </div>
    </section>
  );
};

export default Contact;
